export default __webpack_public_path__ + "static/media/pattern_two.bc1073c9.png";